module.exports = __webpack_public_path__ + "static/media/mohd_loading.afb42779.gif";